import React from 'react';
import authRoles from '../../../auth/authRoles';
import MessagingThread from './messaging/messagingThread';
import RoomSelection from './messaging/entireRoomSelection';

const Messaging = React.lazy(() => import('./Messaging'));
const AdminChat = React.lazy(() => import('./chat/AdminChat'));
const TeacherChat = React.lazy(() => import('./chat/TeacherChat'));
const ParentAnnouncement = React.lazy(() => import('./parentAnnouncement/ParentAnnouncement'));
const TeacherAnnouncement = React.lazy(() => import('./TeacherAnnouncement/ViewTeacherAnnouncement'));
const MessagingLegacy = React.lazy(() => import('./MessagingLegacy'));
const MessagingListing = React.lazy(() => import('./messaging/messagingListing'));

const MessagingConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/messaging',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Messaging />
				</React.Suspense>
			),
			children: [
				{
					path: '',
					element: (
						<React.Suspense fallback={<>...</>}>
							<AdminChat />
						</React.Suspense>
					),
				},
				{
					path: 'admin/chat/:channelId?',
					element: (
						<React.Suspense fallback={<>...</>}>
							<AdminChat />
						</React.Suspense>
					),
				},
				{
					path: 'teacher',
					element: (
						<React.Suspense fallback={<>...</>}>
							<TeacherChat />
						</React.Suspense>
					),
				},
				{
					path: 'teacher/chat/:channelId?',
					element: (
						<React.Suspense fallback={<>...</>}>
							<TeacherChat />
						</React.Suspense>
					),
				},
				{
					path: 'announcements',
					element: (
						<React.Suspense fallback={<>...</>}>
							<ParentAnnouncement />
						</React.Suspense>
					),
				},
				{
					path: 'announcements/teacher',
					element: (
						<React.Suspense fallback={<>...</>}>
							<TeacherAnnouncement />
						</React.Suspense>
					),
				},
				{
					path: 'announcements/room',
					element: (
						<React.Suspense fallback={<>...</>}>
							<RoomSelection />
						</React.Suspense>
					),
				},
			],
		},
		{
			path: '/messaging/legacy/:newMessageToId?',
			element: (
				<React.Suspense fallback={<>...</>}>
					<MessagingLegacy />
				</React.Suspense>
			),
		},
		{
			path: '/messagingListing',
			element: (
				<React.Suspense fallback={<>...</>}>
					<MessagingListing />
				</React.Suspense>
			),
		},
		{
			path: '/messaging-chat/:directLinkConversationId?/:directLinkStudentId?',
			element: (
				<React.Suspense fallback={<>...</>}>
					<MessagingThread />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default MessagingConfig;
